/**
 * CSS styles for the modal components.
 * Uses inline styles to ensure self-contained SDK without external CSS dependencies.
 * Style values are aligned with the Tailwind design system used in the main app.
 */

export const STYLES = {
  overlay: `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  `,

  overlayVisible: `
    opacity: 1;
  `,

  modal: `
    position: relative;
    background: white;
    border-radius: 12px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    width: 90vw;
    max-width: 900px;
    height: 80vh;
    max-height: 700px;
    overflow: hidden;
    transform: scale(0.95);
    transition: transform 0.2s ease-in-out, width 0.3s ease-in-out, height 0.3s ease-in-out, max-width 0.3s ease-in-out, max-height 0.3s ease-in-out, border-radius 0.3s ease-in-out;
  `,

  modalVisible: `
    transform: scale(1);
  `,

  modalFullscreen: `
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  `,

  closeButton: `
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: white;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    transition: transform 0.15s ease-in-out;
    font-size: 18px;
    color: #6b7280;
    line-height: 1;
  `,

  closeButtonHover: `
    transform: scale(1.1);
  `,

  iframe: `
    width: 100%;
    height: 100%;
    border: none;
  `,

  loader: `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  `,

  spinner: `
    width: 40px;
    height: 40px;
    border: 3px solid hsl(214.3 31.8% 91.4%);
    border-top-color: hsl(221.2 83.2% 53.3%);
    border-radius: 50%;
    animation: nbx-spin 0.8s linear infinite;
  `,

  loaderText: `
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    color: hsl(215.4 16.3% 46.9%);
  `,
} as const;

/**
 * Injects required keyframes animation into the document
 */
export function injectKeyframes(): void {
  const styleId = "nbx-hub-keyframes";
  if (document.getElementById(styleId)) return;

  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = `
    @keyframes nbx-spin {
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}
